module.exports = __webpack_public_path__ + "img/btn-bg-black-sloped.ff4ddfff.svg";